export function fcDecorator(Vue) {
  return Vue.directive('decorator', {});
}

export default {
  // just for tag
  install: Vue => {
    fcDecorator(Vue);
  },
};
